import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import { ASSETS, CONTACT } from "@/lib/pnp";

export default function LegalLayout({ title, kicker, children }) {
  return (
    <main className="min-h-screen bg-white text-[#082E19]">
      <header className="border-b border-[#DFEBE4] bg-white/90 backdrop-blur-xl sticky top-0 z-40">
        <div className="flex items-center justify-between px-6 md:px-12 h-16 md:h-20">
          <Link to="/" data-testid="legal-back-home" className="flex items-center gap-3 group">
            <div className="h-10 w-10 rounded-full overflow-hidden ring-1 ring-[#DFEBE4]">
              <img src={ASSETS.logo} alt="P&P Gartenservice" className="h-full w-full object-cover" />
            </div>
            <div className="flex flex-col leading-tight">
              <span className="font-display font-bold text-[15px] tracking-tight">P&amp;P</span>
              <span className="font-mono-pp text-[10px] uppercase tracking-widest text-[#4F6858]">Gartenservice</span>
            </div>
          </Link>
          <Link to="/" className="pp-btn pp-btn-ghost">
            <ArrowLeft size={16} /> Zurück
          </Link>
        </div>
      </header>

      <section className="px-6 md:px-12 pt-16 md:pt-24 pb-8 max-w-3xl">
        <div className="font-mono-pp text-[11px] uppercase tracking-[0.24em] text-[#4F6858] mb-6">
          {kicker}
        </div>
        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          className="font-display font-extrabold tracking-tighter leading-[0.9]"
          style={{ fontSize: "clamp(2.5rem, 6.5vw, 5rem)" }}
        >
          {title}
        </motion.h1>
      </section>

      <section className="px-6 md:px-12 pb-24 md:pb-40 max-w-3xl">
        <div className="prose prose-neutral max-w-none text-[15px] md:text-base leading-relaxed text-[#082E19]">
          {children}
        </div>
      </section>

      <footer className="border-t border-[#DFEBE4] px-6 md:px-12 py-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-[11px] font-mono-pp uppercase tracking-[0.2em] text-[#4F6858]">
        <div>© {new Date().getFullYear()} P&amp;P Gartenservice · Paul Drechsler</div>
        <div className="flex gap-6">
          <Link to="/impressum" className="hover:text-[#082E19]">Impressum</Link>
          <Link to="/datenschutz" className="hover:text-[#082E19]">Datenschutz</Link>
          <a href={CONTACT.emailHref} className="hover:text-[#082E19] normal-case tracking-normal">{CONTACT.email}</a>
        </div>
      </footer>
    </main>
  );
}
